// react
import React, { Fragment, useEffect, useReducer, useState } from 'react';

// styles
import styles from './index.module.scss';
// components
import { NavHeader } from '../../../components/navHeader/index';
import { FormsInfo } from '../../../components/formsInfo/index';
import { Message } from '../../../components/message/index';
import { Note } from '../../../components/note/index';
import { BtnSmall } from '../../../components/btns/btnSmall';
// reducer
import {
  componentStatesInitialState,
  componentStatesReducer,
} from './indexReducer';
// MUI
import Snackbar from '@mui/material/Snackbar';
import Alert from '@mui/material/Alert';
import CircularProgress from '@mui/material/CircularProgress';
// router
import { useNavigate } from 'react-router-dom';
// redux
import { useDispatch, useSelector } from 'react-redux';
import { uiActions } from '../../../store/ui-slice';
/***************************************************************************/
/* Name : FormsDownload React Component */
/***************************************************************************/
const FormsDownloadPage = React.memo(() => {
  const navigate = useNavigate();
  const [studentId, setStudentId] = useState(
    useSelector((state) => state.ui.studentObj._id)
  );
  const [api_url, setApi_url] = useState(
    useSelector((state) => state.ui.api_url)
  );
  const [isCompleted, setIsCompleted] = useState(
    useSelector((state) => state.ui.studentObj.isComplete)
  );
  const [studentCollege, setStudentCollege] = useState(
    useSelector((state) => state.ui.studentObj.college)
  );
  const [isSocial, setIsSocial] = useState(false);
  const [forms, setForms] = useState([
    {
      name: 'استمارة 1',
      value: 'pdf.طلب  الالتحاق',
    },
  ]);

  // reducer
  const [componentStates, dispatchComponentStates] = useReducer(
    componentStatesReducer,
    componentStatesInitialState
  );
  /******************************************************************/
  /* useEffect */
  /******************************************************************/
  useEffect(() => {
    (async () => {
      if (!isCompleted) {
        navigate('/dashboard/studentDataView');
      }
    })();
  }, []);
  useEffect(() => {
    if (studentCollege && studentCollege === 'كلية الخدمة الاجتماعية') {
      setForms([
        {
          name: 'استمارة 1',
          value: 'pdf.طلب  الالتحاق',
        },
        { name: 'استمارة 2', value: 'استمارة الاختبار الشخصي.pdf' },
        { name: 'استمارة 3', value: 'استمارة تعارف.pdf' },
      ]);
      setIsSocial(true);
    }
  }, [studentCollege]);
  /******************************************************************/
  /* downloadFormsHadler1 */
  /******************************************************************/
  const downloadFormsHadler = async () => {
    window.location.href = `${api_url}/api/v1/students/getAdmissionForm/${studentId}`;
  };

  /******************************************************************/
  /* downloadFormsHadler2 */
  /******************************************************************/
  const downloadFormsHadler2 = async () => {
    window.location.href = `${api_url}/api/v1/students/getAcquaintanceForm/${studentId}`;
  };
  /******************************************************************/
  /* downloadFormsHadler3 */
  /******************************************************************/
  const downloadFormsHadler3 = async () => {
    window.location.href = `${api_url}/api/v1/students/getFinalPersonalTestForm/${studentId}`;
  };

  /******************************************************************/
  /* handleCloseSnackbar */
  /******************************************************************/
  const handleCloseSnackbar = () => {
    dispatchComponentStates({ type: 'CLEAR' });
  };
  return (
    <Fragment>
      <NavHeader title={'تنزيل الاستمارات '} />
      <div className={styles['inner-container']}>
        <FormsInfo data={forms} />
        <BtnSmall title={'تنزيل طلب الالتحاق'} onClick={downloadFormsHadler} />
        {isSocial && (
          <Fragment>
            <BtnSmall
              title={'تنزيل استمارة الاختبار الشخصي'}
              onClick={downloadFormsHadler3}
            />
            <BtnSmall
              title={'تنزيل استمارة التعارف'}
              onClick={downloadFormsHadler2}
            />
            <Note
              text={'يرجى متابعة الموقع باستمرار لمعرفة موعد الاختبار الشخصي'}
            />
            <BtnSmall
              title={'موعد الاختبار الشخصي'}
              onClick={() => {
                navigate('/dashboard/studentAppointment');
              }}
            />
          </Fragment>
        )}
      </div>
      {componentStates.pending && (
        <Message text={'يتم الان معالجة البيانات'} type='load' />
      )}
      {/* ********** SUCCESS SNACKBAR ********** */}
      <Snackbar
        open={componentStates.success}
        onClose={handleCloseSnackbar}
        autoHideDuration={2000}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'center',
        }}
      >
        <Alert
          severity='success'
          onClose={handleCloseSnackbar}
          dir='ltr'
          sx={{
            width: '100%',
            backgroundColor: '#43A047',
            color: '#fff',
            fontSize: '1.4rem',
            '& .MuiAlert-icon': {
              color: '#fff',
            },
          }}
        >
          !{componentStates.successMessage}
        </Alert>
      </Snackbar>
      {/* ********** ERROR SNACKBAR ********** */}
      <Snackbar
        open={componentStates.error}
        onClose={handleCloseSnackbar}
        autoHideDuration={20000}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'center',
        }}
      >
        <Alert
          severity='error'
          onClose={handleCloseSnackbar}
          dir='ltr'
          sx={{
            width: '100%',
            backgroundColor: '#D32F2F',
            color: '#fff',
            fontSize: '1.4rem',
            '& .MuiAlert-icon': {
              color: '#fff',
            },
          }}
        >
          !{componentStates.errorMessage}
        </Alert>
      </Snackbar>
    </Fragment>
  );
});

export { FormsDownloadPage };
